export class RobustnessAnalysis {
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;

  public rating: number; // TODO: To remove
  public global_robustness_rating: number;
  public conditional_performance: any;
  public robust_risk_adjusted_performance: any;
  public worst_rolling_risk_statistics: any;
  public outperformance_probability: any;
  public simulation: any;

  constructor() {}

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.creation_date             = data.creation_date ? new Date(data.creation_date) : this.creation_date;
    this.inception_date            = data.inception_date ? new Date(data.inception_date) : this.inception_date;
    this.last_date                 = data.last_date ? new Date(data.last_date) : this.last_date;

    this.global_robustness_rating         = data.global_robustness_rating ? data.global_robustness_rating : this.global_robustness_rating;
    this.conditional_performance          = data.conditional_performance ? data.conditional_performance : this.conditional_performance;
    this.robust_risk_adjusted_performance = data.robust_risk_adjusted_performance ? data.robust_risk_adjusted_performance : this.robust_risk_adjusted_performance;
    this.worst_rolling_risk_statistics    = data.worst_rolling_risk_statistics ? data.worst_rolling_risk_statistics : this.worst_rolling_risk_statistics;
    this.outperformance_probability       = data.outperformance_probability ? data.outperformance_probability : this.outperformance_probability;
    this.simulation                       = data.simulation ? this.parseSimulationVersion(data.simulation) : this.simulation;
  }

  parseSimulationVersion(simulation_data: any) {
    if (!('version' in simulation_data)) {
      return {
        bootstrapping: {
          three_years: {
            returns_distribution: simulation_data.bootstrapping_3y.returns,
            volatility_distribution: simulation_data.bootstrapping_3y.volatility,
            returns_density: simulation_data.bootstrapping_3y.density,
            volatility_density: undefined,
          }
        }
      };
    }
    return simulation_data;
  }
}
